import { render } from "./LayoutDefault.vue?vue&type=template&id=24ed5ea4"
import script from "./LayoutDefault.vue?vue&type=script&lang=js"
export * from "./LayoutDefault.vue?vue&type=script&lang=js"

import exportComponent from "/home/sufoservices/public_html/admin.sufoservices.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__